import { isEmpty } from '@/utils/index.js'
function createAnimationService (bindElement, scaleValue, moveY = '40px', playTime = '1s', animationType = 'ease') {
  if (!bindElement) {
    return
  }

  // 返回播放函数
  return [
    bindElement,
    () => {
      bindElement.getBoundingClientRect()
      bindElement.style.transform = `scale(${scaleValue}) translateY(${moveY})`
      bindElement.style.opacity = 0
      bindElement.getBoundingClientRect()
      bindElement.style.transition = `all ${playTime} ${animationType}`
      bindElement.style.transform = ''
      bindElement.style.opacity = 1
      bindElement.addEventListener('transitionend', () => {
        bindElement.style.transition = ''
      })
    }
  ]
}

const elMap = new WeakMap()

const ob = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const {play, waitTime, isPlayOnce} = elMap.get(entry.target)
      if (!play || typeof play !== 'function') {
        ob.unobserve(entry.target)
        return
      }
      setTimeout(() => {
        play()
      }, waitTime * 1000)
      if (isPlayOnce) {
        ob.unobserve(entry.target)
      }
    }
  })
},
{
  root: null,
  rootMargin: '0px',
  threshold: 0
})

export default {
  bind (el, binding, component) {
    const playInfo = {
      scaleValue: binding.value || '0.95'
    }

    // 是否只播放一次
    let isPlayOnce = false

    // 向上移动的距离
    let moveY = '40px'

    let waitTime = 0
    let playTime = '0.7s'
    let animationType = 'cubic-bezier(.16,1,.3,1)'
    if (component.data.attrs) {
      // 等待时间
      if (!isEmpty(component.data.attrs['system-first-in-scale-wait'])) {
        waitTime = component.data.attrs['system-first-in-scale-wait']
      }
      // 播放时间
      if (!isEmpty(component.data.attrs['system-first-in-scale-play-time'])) {
        playTime = component.data.attrs['system-first-in-scale-play-time']
      }
      // 动画类型
      if (!isEmpty(component.data.attrs['system-first-in-scale-animation-type'])) {
        animationType = component.data.attrs['system-first-in-scale-animation-type']
      }
      //   是否只播放一次
      if (!isEmpty(component.data.attrs['system-first-in-scale-play-once'])) {
        isPlayOnce = component.data.attrs['system-first-in-scale-play-once']
      }
    }

    setTimeout(() => {
      const [observeDom, play] = createAnimationService(el, playInfo.scaleValue, moveY, playTime, animationType)
      ob.observe(observeDom)

      elMap.set(observeDom, {
        play,
        isPlayOnce,
        waitTime
      })
    })
  },
  unbind (el) {
    ob.unobserve(el)
    elMap.delete(el)
  }
}



// WEBPACK FOOTER //
// ./src/directive/firstInViewPort/scale.js